import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

export const PdfViewer = ({fileUrl}: any) => {

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

// cedula_name_saved_name
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      <div style={{ height: '750px' }}>
        <Viewer 
           fileUrl={fileUrl}
           plugins={[defaultLayoutPluginInstance]}  />
      </div>
    </Worker>
  );
};




//  <PdfViewer fileUrl="/ejemplo.pdf" />